'use client'

import Button from '@/components/ui/button'
import { useTranslations } from 'next-intl'
import { useAuthModal } from './useAuthModal'

export default function LoginButton() {
  const t = useTranslations('header')
  const { onOpen: openAuthModal } = useAuthModal()

  const handleClick = () => {
    openAuthModal('login')
  }

  return (
    <Button
      variant='text'
      color='primary'
      fontSize='xs'
      size='md'
      onClick={handleClick} 
      data-tag-id='Login'
    >
      {t('login-button')}
    </Button>
  )
}
